export enum CONFIRM_BUTTON_TEXT {
  confirm = "Confirm",
  changeAutopay = "Change Autopay",
  yes = "Yes",
  default = "Ok"
}

export enum CANCEL_BUTTON_TEXT {
  default = "Cancel",
  no = "No",
  close = "Close"
}